/*
 * Swaps a product card's image to the clicked variant's image instead of
 * navigating to the variant URL. Shared by every section that renders the
 * 'variant-image-swatches' snippet.
 */
if (!customElements.get('variant-swatches')) {
  customElements.define(
    'variant-swatches',
    class VariantSwatches extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick = (event) => {
        const swatch = event.target.closest('.models-swatch--image');
        if (!swatch || !this.contains(swatch)) return;

        event.preventDefault();

        const card = this.closest('.models-card') || this.closest('.card');
        if (!card) return;

        /*
         * The theme's hover carousel and secondary-image overlay both target
         * the same <img>, which would undo the colour the shopper picked.
         * Remove them from this card on first interaction.
         */
        const carousel = card.querySelector('secondary-media');
        if (carousel) carousel.remove();

        const secondary = card.querySelector('.product-card__secondary');
        if (secondary) secondary.remove();

        card.classList.add('has-swatch-selection');

        const image = card.querySelector('.product-card__media img');
        if (!image) return;

        const src = swatch.dataset.mediaSrc;
        if (!src) return;

        // Preload so the swap does not flash an empty frame.
        const preload = new Image();
        preload.onload = () => {
          image.src = src;
          if (swatch.dataset.mediaSrcset) image.srcset = swatch.dataset.mediaSrcset;
          if (swatch.dataset.mediaAlt) image.alt = swatch.dataset.mediaAlt;
          image.removeAttribute('sizes');
        };
        preload.src = src;

        this.querySelectorAll('.models-swatch').forEach((el) => {
          const active = el === swatch;
          el.classList.toggle('is-active', active);
          if (el.hasAttribute('aria-pressed')) {
            el.setAttribute('aria-pressed', active ? 'true' : 'false');
          }
        });

        // Keep the card's link pointing at the colour the shopper is viewing.
        if (swatch.dataset.variantUrl) {
          card.querySelectorAll('a.product-card__title, a.media-card__link').forEach((link) => {
            link.href = swatch.dataset.variantUrl;
          });
        }
      };
    }
  );
}
